import moment from "moment";
import countdown from "countdown";
import { lifecycle } from "recompose";

export default lifecycle({
  componentDidMount() {
    window.setInterval(() => {
      this.forceUpdate();
    }, 1000);
  }
})(({ time }) => countdown(moment(time)).toString());



// WEBPACK FOOTER //
// ./src/components/generic/kit/Countdown/index.js